import { render } from "./myClubs.vue?vue&type=template&id=425cb73b&scoped=true&ts=true"
import script from "./myClubs.vue?vue&type=script&lang=ts"
export * from "./myClubs.vue?vue&type=script&lang=ts"

import "./myClubs.vue?vue&type=style&index=0&id=425cb73b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425cb73b"]])

export default __exports__